// extracted by mini-css-extract-plugin
module.exports = {"processingIcon":"icons_processingIcon__3zyVi","successIcon":"icons_successIcon__3Av7y","failureIcon":"icons_failureIcon__2RoMg"};